import React, {useEffect, useState} from "react";
import {Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import Input from "../../../common/Input";
import TextArea from "../../../common/TextArea";
import {getGreekCurrencyFormat, isEmpty, isValidEmail} from "../../../../_helpers/commonFunctions";
import moment from "moment";
import {toast} from "react-toastify";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import Dropdown from "../../Dropdown";
import {openSaleLocal} from "../../../../_helpers/tabOpeners";

const EmronMonthlyPaymentDetails = (props) => {
    //props.data for table row data
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const ACTIVE_MAIN_TAB = useSelector((state) => state.ACTIVE_MAIN_TAB);
    const tabKey = TABS_DATA[ACTIVE_MAIN_TAB].key;
    const editClient = useSelector((state) => state.CLIENTS_DATA.editClient[tabKey]);
    const [show, setShow] = useState(false);
    const [wooData, setWooData] = useState({
        startDate: "",
        endDate: "",
        nextPaymentDate: "",
        nextPaymentAmount: "",
        tableData: [],
    });

    const [showSendEmail, setShowSendEmail] = useState(false);
    const [loadingEmail, setLoadingEmail] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState("");
    const [availableEmails, setAvailableEmails] = useState([]);
    const [customEmail, setCustomEmail] = useState("");

    useEffect(() => {
        if (show && props.data.wooResponse) {
            try {
                const dat = JSON.parse(props.data.wooResponse);
                setWooData({
                    ...wooData,
                    status: dat.status,
                    startDate: moment(dat.start_date).format("DD/MM/YYYY HH:mm:ss"),
                    endDate: !isEmpty(dat.end_date) ? moment(dat.end_date).format("DD/MM/YYYY HH:mm:ss") : "",
                    nextPaymentDate: !isEmpty(dat.next_payment_date) ? moment(dat.next_payment_date).format("DD/MM/YYYY HH:mm:ss") : "",
                    nextPaymentAmount: getGreekCurrencyFormat(Number(dat.total)),
                })
            } catch (error) {
                console.log(error);
            }
        }
    }, [show])

    useEffect(() => {
        if (showSendEmail) {
            let emails = [];
            const matchingClient = editClient;
            if (matchingClient.email) emails.push(matchingClient.email);
            for (const cp of matchingClient.contactPoints) {
                emails.push(cp.email);
            }
            emails = emails.filter(Boolean).filter((item, index) => emails.indexOf(item) === index);
            if (emails.length > 0) setSelectedEmail(emails[0]);
            emails = emails.map((o) => {
                return {
                    value: o,
                    label: o,
                }
            });
            emails.push({
                value: "custom",
                label: "Χειροκίνητη εισαγωγή e-mail",
            })
            setAvailableEmails(emails);
        } else {
            setSelectedEmail("");
            setAvailableEmails([]);
            setCustomEmail("");
        }
    }, [showSendEmail]);

    const getStatusText = (status) => {
        let mapTrans = {
            "active": "Ενεργή",
            "cancelled": "Ακυρωμένη",
            "on-hold": "Εκκρεμεί",
            "pending-cancel": "Εκκρεμεί ακύρωση",
            "expired": "Έχει λήξει",
        }
        return mapTrans[status] ? mapTrans[status] : status;
    }

    const handleOrderTransactionViewClicked = (transactionId) => {
        if (!isEmpty(transactionId)) {
            axios.get(process.env.REACT_APP_API_URL2 + "/emron/find-subscription-sale", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    transactionId: transactionId,
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    dispatch(openSaleLocal(res.data.data, TABS_DATA));
                } else {
                    toast.error(res.data.message);
                }
            }).catch((error) => {
                console.log(error);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Δεν βρέθηκε το παραστατικό, παρακαλώ δοκιμάστε αργότερα.");
        }
    }

    const orderPending = (order) => {
        return ["failed", "pending"].includes(order?.status);
    }

    const handleCopyPayNowLink = () => {
        axios.post(process.env.REACT_APP_API_URL2 + "/emron/emron-pay-now-link", {
            vatNumber: editClient.vatNumber,
        }).then((res) => {
            if (res.data.status === "200") {
                navigator.clipboard.writeText(res.data.linkURL).then(() => {
                    toast.info("Ο σύνδεσμος αντιγράφηκε επιτυχώς.");
                })
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleSendEmail = () => {
        let finalEmail;
        if (selectedEmail === "custom") {
            finalEmail = customEmail;
        } else {
            finalEmail = selectedEmail;
        }
        if (isEmpty(finalEmail) || !isValidEmail(finalEmail)) return toast.error("Παρακαλώ συμπληρώστε έγκυρο e-mail.");

        setLoadingEmail(true);
        axios.post(process.env.REACT_APP_API_URL2 + "/emron/pay-now-email", {
            vatNumber: editClient.vatNumber,
            email: finalEmail,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής αποστολή ειδοποίησης μέσω e-mail.");
                setShowSendEmail(false);
            } else {
                toast.error(res.data.message);
            }
            setLoadingEmail(false);
        }).catch((err) => {
            setLoadingEmail(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <React.Fragment>
            <Button style={{pointerEvents: "auto", padding: "2px", margin: "8px"}} size={"sm"} variant={"default"} title={props.title ? props.title : "Πληροφορίες"} onClick={() => setShow(true)}>
                <i className="fa-regular fa-file-lines"></i>
            </Button>

            <Modal backdrop={"static"} show={show} onHide={() => setShow(false)} dialogClassName={"modal40PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Πληροφορίες Μηνιαίας Χρέωσης</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className={"mb-2"}>
                        <Col md={6}>
                            <Input label={"Αρ. Συνδρομής"} disabled={true} value={props.data.subscription_id} />
                        </Col>
                        <Col md={6}>
                            <Input label={"Κατάσταση"} disabled={true} value={getStatusText(wooData.status)} />
                        </Col>
                    </Row>
                    <Row className={"mb-2"}>
                        <Col md={6}>
                            <Input label={"Ημερομηνία Έναρξης"} disabled={true} value={wooData.startDate} />
                        </Col>
                        <Col md={6}>
                            <Input label={"Ημερομηνία Λήξης"} disabled={true} value={isEmpty(wooData.endDate) ? "Χωρίς ημ/νια λήξης" : wooData.endDate} />
                        </Col>
                    </Row>
                    <Row className={"mb-2"}>
                        <Col md={6}>
                            <Input label={"Ημερομηνία Επόμενης Πληρωμής"} disabled={true} value={isEmpty(wooData.nextPaymentDate) ? "-" : wooData.nextPaymentDate} />
                        </Col>
                        <Col md={6}>
                            <Input label={"Ποσό Επόμενης Πληρωμής"} disabled={true} value={isEmpty(wooData.nextPaymentDate) ? "-" : wooData.nextPaymentAmount} />
                        </Col>
                    </Row>
                    <Row className={"mb-2"}>
                        <Col md={12}>
                            <TextArea
                                label={"Σημειώσεις"}
                                rows={3}
                                disabled={true}
                                value={props.data.notes}
                            />
                        </Col>
                    </Row>
                    {props.data?.orders?.length > 0 && (
                        <Row>
                            <Col md={12}>
                                <div style={{textAlign: "center"}}><h6>Ιστορικό παραγγελιών</h6></div>
                                <table style={{tableLayout: "fixed", width: "100%", textAlign: "center"}}>
                                    <thead>
                                    <tr>
                                        <th style={{border: "1px solid gray"}}>Ημ/νια πληρωμής</th>
                                        <th style={{border: "1px solid gray"}}>Αρ. Παραγγελίας</th>
                                        <th style={{border: "1px solid gray"}}>Transaction ID</th>
                                        <th style={{border: "1px solid gray"}}>Ποσό πληρωμής</th>
                                        <th style={{border: "1px solid gray", width: "50px"}}>&nbsp;</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {props.data?.orders?.map((order, idx) => (
                                        <tr key={`orderRowEP${idx}`}>
                                            <td style={{border: "1px solid gray"}}>{isEmpty(order.date_paid) ? "-" : moment(order.date_paid).format("DD/MM/YYYY HH:mm:ss")}</td>
                                            <td style={{border: "1px solid gray"}}>{order.id}</td>
                                            <td style={{border: "1px solid gray"}}>{isEmpty(order.transaction_id) ? "-" : order.transaction_id}</td>
                                            <td style={{border: "1px solid gray"}}>{getGreekCurrencyFormat(Number(order.total))}</td>
                                            <td style={{
                                                border: "1px solid gray",
                                                width: "25px"
                                            }}>
                                                {!isEmpty(order.transaction_id) && (
                                                    <i className="fa-regular fa-file-lines"
                                                       style={{padding: 0, cursor: "pointer"}}
                                                       title={"Προβολή Παραστατικού"}
                                                       onClick={() => handleOrderTransactionViewClicked(order.transaction_id)}>
                                                    </i>
                                                )}
                                                {orderPending(order) && (
                                                    <React.Fragment>
                                                        <i className="fa-solid fa-envelope mr-1"
                                                           style={{padding: 0, cursor: "pointer"}}
                                                           title={"Αποστολή e-mail"}
                                                           onClick={() => setShowSendEmail(true)}>
                                                        </i>
                                                        <i className="fa-solid fa-link"
                                                           style={{padding: 0, cursor: "pointer"}}
                                                           title={"Αντιγραφή συνδέσμου άμεσης πληρωμής"}
                                                           onClick={() => handleCopyPayNowLink(order)}>
                                                        </i>
                                                    </React.Fragment>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShow(false)}>
                        Κλείσιμο
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showSendEmail} onHide={() => setShowSendEmail(false)} backdrop={"static"}>
                <Modal.Header closeButton={!loadingEmail}>
                    <Modal.Title>Αποστολή e-mail</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={"mb-1"}>Παρακαλώ επιλέξτε το e-mail που θα αποστείλετε την ειδοποίηση</div>
                    <Dropdown
                        name={"selectedEmail"}
                        options={availableEmails}
                        defaultValue={availableEmails.find((el) => el.value === selectedEmail)}
                        key={selectedEmail}
                        onChange={(e) => setSelectedEmail(e.value)}
                    />
                    {selectedEmail === "custom" && (
                        <Input
                            name={"customEmail"}
                            value={customEmail}
                            label={"Χειροκίνητη εισαγωγή e-mail"}
                            placeholder={"Εισάγετε e-mail"}
                            onChange={(e) => setCustomEmail(e.target.value)}
                        />
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowSendEmail(false)} disabled={loadingEmail}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => handleSendEmail()} disabled={loadingEmail}>
                        Αποστολή e-mail {loadingEmail && <Spinner className={"ml-2"} animation="border" variant="dark" />}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default EmronMonthlyPaymentDetails;
